import Content from "./Content";
import { IWizardStep } from "../../../../wizard/types";

export const createConfigStep5: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Preview",
  },
  content: Content,
  stepName: "step5",
};
